import * as meta from '@/api/meta'

const state = {
  usuario: null,
  periodo: 'mes',
  dados: {
    total: 0,
    novas_tentativas: 0,
    total_em_atendimento: 0,
    qtd_nao_atendido: 0,
    qtd_atendido: 0,
    quentes: { qtd: 0, total: 0, contratos: 0 },
    mornos: { qtd: 0, total: 0, contratos: 0 },
    frios: { qtd: 0, total: 0, contratos: 0 },
    assinaturas: { qtd: 0, total: 0, contratos: 0 },
    fechados: { qtd: 0, total: 0, contratos: 0 },
    descartados: { qtd: 0, total: 0, contratos: 0 },
    homens: { qtd: 0, total: 0, contratos: 0 },
    mulheres: { qtd: 0, total: 0, contratos: 0 }
  }
}

const mutations = {
  SETUSUARIO (state, data) {
    state.usuario = data
  },
  SETPERIODO (state, data) {
    state.periodo = data
  },
  SETESTATISTICA (state, data) {
    // Dados
    let dados = {
      total: 0,
      novas_tentativas: 0,
      total_em_atendimento: 0,
      qtd_nao_atendido: 0,
      qtd_atendido: 0,
      quentes: {},
      mornos: {},
      frios: {},
      assinaturas: {},
      fechados: {},
      descartados: {},
      homens: {},
      mulheres: {},
      totais: {}
    }

    dados.novas_tentativas = data.novas_tentativas
    dados.total_em_atendimento = data.total_em_atendimento
    dados.qtd_nao_atendido = data.nao_atendidos
    dados.qtd_atendido = data.atendidos
    dados.total = data.total
    dados.quentes = data.quentes
    dados.mornos = data.mornos
    dados.frios = data.frios
    dados.assinaturas = data.fechamentos
    dados.fechados = data.fechados
    dados.descartados = data.descartados
    dados.homens = data.homens
    dados.mulheres = data.mulheres
    // Set
    state.dados = dados
  }
}

const actions = {
  async changeUsuario ({ commit }, usuario) {
    commit('SETUSUARIO', usuario)
  },
  async changePeriodo ({ commit }, periodo) {
    commit('SETPERIODO', periodo)
  },
  async atualiza ({ dispatch }) {
    await dispatch('estatisticaTlmk')
  },
  async estatisticaTlmk ({ state, commit }) {
    let param = { periodo: state.periodo }
    if (state.usuario) param.usuario_id = state.usuario
    commit('SETESTATISTICA', await meta.estatisticaTlmk(param))
  }
}

export default { namespaced: true, state, actions, mutations }



// WEBPACK FOOTER //
// ./src/store/modules/performance.js